import { useQuery } from "react-query"
import { getPostPayout } from "@requests/payouts"
import type { PerformerInterest } from "@pages/PayoutDistributionPage/types"

interface PostPayoutResponse {
  payout_id: number | null
  status: string | null
  post: {
    id: number
    title: string
    published_at: string
    has_bandnada_tickets: boolean
    tickets_sold: number
    total_revenue: number
    bn_share: number
    band_share: number
  }
  performers: PerformerInterest[]
}

export function usePostPayout(postId: number | null | undefined) {
  return useQuery<PostPayoutResponse>(
    ["post_payout", postId],
    () => getPostPayout(postId!),
    { enabled: !!postId },
  )
}
